import React, { useState } from 'react'
import './../styles/HomePage.scss'
import shareicon from './../img/share-icon.svg'
import Api from '../common/api'


const HomePage = () => {

  const [isActive, setIsActive] = useState(false)


  React.useEffect(() => {
    if (localStorage.getItem('cookie') == "true") {
      handleCookie(true);
    }
    Api.get("/home/getslider").then((res) => {
      setSlider(res.data.items)

    });
  }, []);

  const [sliderItem, setSlider] = useState()


  const setCookie = (data) => {
    if (data === true) {
      localStorage.setItem('cookie', data);
    }
  }


  const [isOpen, handleCookie] = useState(false)



  const CookieText = () => {
    return (
      <div className="cookie-popup" style={{ display: isOpen ? "none" : "flex" }}>
        <div className="cookie-text">
          <p className="footer-cookie">
          We use cookies to improve your experience on our site. Cookies enable you to better experience certain features and use the site effectively. You can accept all cookies by clicking "Accept".
          </p>
          <p>Please review the  <a target="_blank" href="https://sankoenerji.com.tr/Uploads/MediaCenter/SankoEnerji_General_Disclaimer_Personal_Data_Protection_Processing.pdf">Privacy </a>and ve <a target="_blank" href="https://sankoenerji.com.tr/Uploads/MediaCenter/SankoEnerji_Cookie_Policy_Disclaimer.pdf">Cookie Policy </a>for detailed information.
               </p>
        </div>
        <button className="button" onClick={() => { setCookie(true); handleCookie(true) }}>Accept</button>
        <button className="close" onClick={() => { handleCookie(true) }}>x</button>
      </div>
    )
  }

  return (
    <div className="home-page" style={
      sliderItem ? {
        backgroundImage: `url(${"https://sankoenerji.com.tr" + sliderItem.Image})`,
      } : null} >
      <div className="social-btn">
        <button onClick={() => setIsActive(!isActive)} className="social-media-btn">
          <img src={shareicon} alt="shareicon" />
          {isActive ?
            <div className="social-media-btns">
              <a href="https://twitter.com/Sanko_Enerji" target="blank">
                <i className="fab fa-twitter homepage-social-media-icon"></i>
              </a>
              <a href="https://www.linkedin.com/company/sanko-enerji/" target="blank">
                <i className="fab fa-linkedin homepage-social-media-icon"></i>
              </a>
              <a href="https://www.youtube.com/channel/UCSZSxCQi338RlyzE2qrWAKQ" target="blank">
                <i className="fab fa-youtube homepage-social-media-icon"></i>
              </a>
              <a href="https://www.facebook.com/sankoenergy/" target="blank">
                <i className="fab fa-facebook-square homepage-social-media-icon"></i>
              </a>
              <a href="https://www.instagram.com/sankoenerji/" target="blank">
                <i className="fab fa-instagram homepage-social-media-icon"></i>
              </a>
            </div>
            : null}
        </button>
      </div>
      <CookieText />
    </div>
  )
}

export default HomePage